@if (appLoaded) {
  <div class="main-container d-flex" [ngClass]="{'geoview-page': isGeoviewPage, 'onboarding-page': isOnboardingPage, 'invite-page': isInvitePage}">
    @if (!isOnboardingPage && !isInvitePage) {
      <app-sidebar
        [expanded]="(preferences$ | async).sidebar"
        (expandedChange)="toggleMenu($event)"
        [user]="user"
      ></app-sidebar>
    }
    <div class="main-body" [class.full-width]="isOnboardingPage || isDataManagementPage || isInvitePage">
      <router-outlet></router-outlet>
    </div>
  </div>
}
<app-loader></app-loader>
